<template>
  <v-col
    cols="12"
    md="4"
    class="pt-12 text-center"
  >
    <div
      style="max-width: 250px; margin: auto;"
    >
      <v-avatar
        size="150"
      >
        <img
          :src="member.img"
          :alt="member.name"
        >
      </v-avatar>
      <div style="height: 20px;" />
      <v-card
        class="mx-auto"
        max-width="344"
        style="margin-top: -10px; min-height: 335px;"
      >
        <v-card-text>
          <p class="title text--primary">
            {{ member.name }}
          </p>
          <p>{{ $t(member.level) }}</p>
          <div class="text--primary">
            {{ $t(member.shortDescription) }}
          </div>
        </v-card-text>
        <v-card-actions
          justify="right"
        >
          <v-btn
            text
            color="primary"
            style="position: absolute; bottom: 10px; right: 10px;"
            @click="dialog = true"
          >
            + Info
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          {{ member.name }}
        </v-card-title>

        <v-card-text>
          {{ $t(member.description) }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            align="bottom"
            color="grey darken-1"
            text
            @click="dialog = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
  export default {
    props: {
      member: {
        type: Object,
        default: function () { return 'Unknown' }
      }
    },
    data: () => ({
      dialog: false
    })
  }
</script>
